import React from 'react'
import styled from '@emotion/styled'

export const V2L1DashboardListHeader = styled.div(({theme}) => ({
	backgroundColor: theme.colors.blueMain,
	borderRadius: theme.borderRadius,
	borderBottomLeftRadius: 0,
	borderBottomRightRadius: 0,
	...theme.fonts.titleBold,
	fontSize: '14px',
	textTransform: 'uppercase',
	lineHeight: theme.spacing(4),
	color: theme.colors.white,
	display: 'flex',
	alignItems: 'center',
	padding: theme.spacing(0, 2),
}))

export const V2L1DashboardListHeaderTitle = styled.div(({theme}) => ({
	display: 'flex',
	flexDirection: 'row',
	gap: theme.spacing(1),
	alignItems: 'center',
}))
